import {useEffect, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';
import {ButtonProps} from '@guestapp/old-ui-kit';
import warning from '../../../assets/icons/warning-icon.svg?no-inline';
import StandardModalSheet from 'components/common/StandardModalSheet';
import {StyledIncompleteGuestsModal} from './styled';
import {useModalControls} from '@chekin/guestapp-ui-kit';

type Props = {
  onCompleteGuestData?: () => void;
  onShareRegistrationLink?: () => void;
};
function IncompleteGuestsModal({onCompleteGuestData, onShareRegistrationLink}: Props) {
  const {t} = useTranslation();
  const {state} = useLocation();
  const {openModal, closeModal, isOpen} = useModalControls();

  const modalSheetButtons: ButtonProps[] = useMemo(() => {
    const primaryButton: ButtonProps = {
      label: 'complete_guest_data',
      primary: true,
      onClick: () => {
        closeModal();
        onCompleteGuestData?.();
      },
    };

    const secondaryButton: ButtonProps = {
      link: true,
      label: 'share_registration_link',
      onClick: () => {
        closeModal();
        onShareRegistrationLink?.();
      },
    };

    return [primaryButton, secondaryButton];
  }, [closeModal, onCompleteGuestData, onShareRegistrationLink]);

  useEffect(() => {
    if (state?.hasIncompleteGuests) {
      openModal();
    }
  }, [openModal, state]);

  return (
    <StyledIncompleteGuestsModal
      isOpenModalSheet={isOpen}
      handleCloseModal={closeModal}
      title={t('incomplete_guest_data')}
      closeOnDocumentClick={false}
      withCloseButton
      closeOnEscape
      closeButtonType="click"
      iconProps={{
        src: warning,
        alt: 'warning',
      }}
    >
      <StandardModalSheet
        buttons={modalSheetButtons}
        text={t('incomplete_guest_data_text')}
      />
    </StyledIncompleteGuestsModal>
  );
}

export {IncompleteGuestsModal};
